import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "../Style.scss";
import { Container } from "react-bootstrap";

export class PrivacyPolicy extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Privacy Policy ~ Algoquant Global</title>
        </Helmet>
        <div className="wrapper privacyPolicyContainer">
          <div className="privacyPolicyHeader container headerforall">
            <div className="rightHeader">
              <h1>Privacy Policy</h1>
            </div>
            <div className="leftHeader">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/" className="inActive">
                      Home
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    Privacy Policy
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <hr width="100%" />
          <Container className="privacyPolicy paragraphforall">
            <p className="disc">
              We at Algoquant Global do our best to ensure the
              information shared with us is stored in a safe and Secure manner.
              Personal information collected by us is used to help provide you
              products and services as per your choice.
            </p>
            <p className="disc">
              Any personally identifiable information of the customers obtained
              by us shall not be used or shared other than for the purposes to
              which the customers consents. However security and confidentiality
              of information cannot be guaranteed cent percent. Hence despite
              our utmost efforts to protect your personal information Algoquant Global cannot warrant the security of any
              information you transmit to us through our online services. Such
              transmission of your personal information is done at your own
              risk, but we guarantee that your privacy information will not be
              sold out to any company for marketing and promotion purpose.
            </p>
            <p className="disc">
              We would also impart your personal information wherever it is
              required to be disclosed under any law for the time being in force
              or to any of the governmental agency or regulatory bodies.
            </p>
            <p className="disc">
              All information gathered will be stored using firewall software in
              order to ensure that your information is secure and safe. And
              further to bring it to your notice your information is treated
              with utmost care and secrecy and it may be used by Algoquant Global for the intent of business communication if needed.
            </p>
            <p className="disc">
              Our website may contain links to other websites of interest.
              However, once you have used these links to leave our site, you
              should note that we do not have any control over that other
              website. Therefore, we cannot be responsible for the protection
              and privacy of any information which you provide whilst visiting
              such sites and such sites are not governed by this privacy
              statement. You should exercise caution and look at the privacy
              statement applicable to the website in question.
            </p>
          </Container>
        </div>
      </>
    );
  }
}

export default PrivacyPolicy;
